/* Punartha sticky buy bar: slides up while the product page's own buy buttons
   are off screen, and proxies clicks to them. Mirrors their disabled state and
   the live variant price. */
if (!customElements.get('sticky-buy-bar')) {
  customElements.define(
    'sticky-buy-bar',
    class StickyBuyBar extends HTMLElement {
      connectedCallback() {
        const sectionId = this.dataset.sectionId;
        this.realBuy = document.getElementById(`ProductBuyNowButton-${sectionId}`);
        this.realCart = document.getElementById(`ProductSubmitButton-${sectionId}`);
        this.price = document.getElementById(`price-${sectionId}`);
        this.barBuy = this.querySelector('[data-sticky-buy]');
        this.barCart = this.querySelector('[data-sticky-cart]');
        this.barPrice = this.querySelector('[data-sticky-price]');
        const target = this.realCart?.closest('.product-form__buttons');
        if (!target || !this.realCart) return;

        if (!this.realBuy) this.barBuy.hidden = true;
        this.barBuy.addEventListener('click', () => this.realBuy?.click());
        this.barCart.addEventListener('click', () => this.realCart.click());

        this.observers = [];
        this.intersection = new IntersectionObserver(([entry]) => this.toggle(!entry.isIntersecting), {
          threshold: 0,
        });
        this.intersection.observe(target);

        this.sync();
        const watch = (el, options) => {
          if (!el) return;
          const observer = new MutationObserver(() => this.sync());
          observer.observe(el, options);
          this.observers.push(observer);
        };
        watch(this.realCart, { attributes: true, attributeFilter: ['disabled', 'class'] });
        watch(this.realBuy, { attributes: true, attributeFilter: ['disabled', 'class'] });
        watch(this.price, { childList: true, subtree: true, characterData: true });
      }

      disconnectedCallback() {
        this.intersection?.disconnect();
        this.observers?.forEach((observer) => observer.disconnect());
      }

      toggle(show) {
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', String(!show));
        [this.barBuy, this.barCart].forEach((button) => (button.tabIndex = show ? 0 : -1));
      }

      sync() {
        const soldOut = this.realCart.hasAttribute('disabled');
        this.barCart.disabled = soldOut;
        this.barBuy.disabled = soldOut;
        this.barBuy.classList.toggle('loading', !!this.realBuy?.classList.contains('loading'));
        this.barCart.classList.toggle('loading', this.realCart.classList.contains('loading'));
        if (soldOut) this.barBuy.textContent = this.realCart.innerText.trim();
        else if (this.realBuy) this.barBuy.textContent = this.realBuy.innerText.trim();

        const price = this.price?.querySelector('.price');
        if (!price) return;
        const current = price.classList.contains('price--on-sale')
          ? price.querySelector('.price__sale .price-item--last')
          : price.querySelector('.price__regular .price-item--regular');
        if (current) this.barPrice.textContent = current.textContent.trim();
      }
    }
  );
}
